/**
 * Whether a failure is a cancellation rather than a defect.
 *
 * The canonical shape is the `DOMException` that `fetch`, a stream read, or any
 * other `AbortSignal`-aware API rejects with. The name check stands alone as a
 * fallback because an abort that crosses a realm boundary — posted out of a web
 * worker, raised by a polyfilled API — keeps its name but loses its
 * `DOMException` identity, and callers uniformly treat an abort as "the caller
 * stopped caring", which is just as true of the re-created error.
 */
export const isAbortError = (err: unknown): err is DOMException | Error =>
  (err instanceof DOMException || err instanceof Error) &&
  err.name === "AbortError";
